import axios from "axios";

const httpClient = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "multipart/form-data",
    "Cache-Control": "no-cache"
    // anything you want to add to the headers
  }
});

export default httpClient;
